import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import {
  ExtensionAuthRoute,
  ExtensionOffboardingRoute,
  ExtensionOnboardingRoute,
  ExtensionRoute,
} from '~/modules/extension';
import {
  ExtensionSidebarClickKey,
  ExtensionSidebarKey,
} from '~/modules/extension/constants';
import analytics from '~/services/analytics';
import extension from '~/services/Extension';
import localStorage from '~/services/storage/localStorage';

const Icon = extension.getIcon();

router.addPrivateRoutes([
  ExtensionOnboardingRoute,
  ExtensionRoute,
  ExtensionAuthRoute,
]);

router.addUnAuthorizedRoutes([ExtensionOffboardingRoute]);
sidebar.addItems({
  a: [
    {
      order: 5,
      key: ExtensionSidebarKey,
      path: ExtensionRoute.path,
      getTitle: ExtensionRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'chrome_extension',
        });

        localStorage.setByKey(ExtensionSidebarClickKey, '1');
      },
      checkAvailability: (): boolean => extension.checkIsExtensionAvailable(),
      // @ts-ignore
      Icon,
    },
  ],
});
